import { render, staticRenderFns } from "./grid_rules_check.vue?vue&type=template&id=2bbfa2fa&scoped=true&lang=html"
import script from "./grid_rules_check.vue?vue&type=script&lang=js"
export * from "./grid_rules_check.vue?vue&type=script&lang=js"
import style0 from "./grid_rules_check.vue?vue&type=style&index=0&id=2bbfa2fa&prod&scoped=true&lang=scss"
import style1 from "./grid_rules_check.vue?vue&type=style&index=1&id=2bbfa2fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbfa2fa",
  null
  
)

export default component.exports